/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_7_Questions_0_AnswerInputs */

const en_gc_search_guides_gridcraft_vs_excel_sections_7_questions_0_answer = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_7_Questions_0_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It is a free, open-source spreadsheet with an Excel-style workflow. Whether it replaces Excel for you depends on your files and required features. Also compare it fairly with Excel’s free web edition, not only with paid desktop plans.`)
};

const zh_gc_search_guides_gridcraft_vs_excel_sections_7_questions_0_answer = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_7_Questions_0_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`它是免费的开源电子表格，操作方式类似 Excel。能否替代 Excel，取决于你的文件与功能要求。对比时也应考虑 Excel 的免费网页版，而不只是付费桌面方案。`)
};

/**
* | output |
* | --- |
* | "It is a free, open-source spreadsheet with an Excel-style workflow. Whether it replaces Excel for you depends on your files and required features. Also compa..." |
*
* @param {Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_7_Questions_0_AnswerInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_vs_excel_sections_7_questions_0_answer = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_7_Questions_0_AnswerInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_7_Questions_0_AnswerInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_vs_excel_sections_7_questions_0_answer(inputs)
	return zh_gc_search_guides_gridcraft_vs_excel_sections_7_questions_0_answer(inputs)
});
export { gc_search_guides_gridcraft_vs_excel_sections_7_questions_0_answer as "gc.search_guides.gridcraft_vs_excel.sections.7.questions.0.answer" }